export default __webpack_public_path__ + "static/media/advanced-deployment-banner.248712ee.png";